import React, { useState } from 'react';
import { Button, Input, Popover, Space } from '@arco-design/web-react';
import { IconFilter, IconSearch, IconRefresh } from '@arco-design/web-react/icon';

const TableFilter = ({ onFilter, placeholder = '请输入关键词' }) => {
  const [visible, setVisible] = useState(false);
  const [filterValue, setFilterValue] = useState('');
  const [hasFilter, setHasFilter] = useState(false);

  const handleFilter = () => {
    onFilter(filterValue);
    setHasFilter(!!filterValue);
    setVisible(false);
  };

  const handleClear = () => {
    setFilterValue('');
    onFilter('');
    setHasFilter(false);
    setVisible(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleFilter();
    }
  };

  const content = (
    <div style={{ width: 165, padding: '8px 0' }}>
      <Input
        placeholder={placeholder}
        value={filterValue}
        onChange={setFilterValue}
        onKeyPress={handleKeyPress}
        style={{ marginBottom: 8 }}
        allowClear
      />
      <Space>
        <Button
          type="primary"
          size="small"
          icon={<IconSearch />}
          onClick={handleFilter}
        >
          筛选
        </Button>
        <Button
          size="small"
          icon={<IconRefresh />}
          onClick={handleClear}
        >
          重置
        </Button>
      </Space>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      visible={visible}
      onVisibleChange={setVisible}
      position="bottom"
    >
      <Button
        size="small"
        icon={<IconFilter />}
        type={hasFilter ? 'primary' : 'secondary'}
        style={{
          color: hasFilter ? '#fff' : '#86909c'
        }}
      />
    </Popover>
  );
};

export default TableFilter;